import registerIcons from '../components/ui/icon/register';
registerIcons();
export { registerIcons };
